export default __webpack_public_path__ + "static/1755-3d427251ef719177d9e9b50a685e6cd4.gif";